// extracted by mini-css-extract-plugin
export default {"row":"RequestDataRow_row__XUhxC","label":"RequestDataRow_label__1t6+f","labelWide":"RequestDataRow_labelWide__ARSeC","value":"RequestDataRow_value__eWqQ8"};